export const OVERFLOW_IDS = {
  NOTIFICATIONS: 'notifications',
  HELP: 'help',
  DARK_MODE: 'dark-mode',
  CLEAR: 'clear-button',
  APPLY: 'apply-filter',
  END_DATE: 'end-date',
  START_DATE: 'start-date',
  MONTH_YEAR: 'month-year',
  SELECT_FILTER: 'select-filter',
  SEARCH_CATEGORY: 'search-category',
  SEARCH: 'search',
  DASHBOARD_PRIMARY: 'dashboard-primary',
  DASHBOARD_SECONDARY: 'dashboard-secondary'
};

/** Utility icons that should stay inline on filter-less form topbars. */
export const UTILITY_OVERFLOW_IDS = [
  OVERFLOW_IDS.DARK_MODE,
  OVERFLOW_IDS.HELP,
  OVERFLOW_IDS.NOTIFICATIONS
];

export const COMPACT_TOPBAR_MEDIA = '(max-width: 767.98px)';

/** Lower number = collapses first (right-side items have lowest numbers). */
export const OVERFLOW_PRIORITY = {
  [OVERFLOW_IDS.NOTIFICATIONS]: 10,
  [OVERFLOW_IDS.HELP]: 20,
  [OVERFLOW_IDS.DARK_MODE]: 30,
  [OVERFLOW_IDS.APPLY]: 40,
  [OVERFLOW_IDS.CLEAR]: 50,
  [OVERFLOW_IDS.END_DATE]: 60,
  [OVERFLOW_IDS.START_DATE]: 70,
  [OVERFLOW_IDS.DASHBOARD_PRIMARY]: 75,
  [OVERFLOW_IDS.DASHBOARD_SECONDARY]: 80,
  [OVERFLOW_IDS.MONTH_YEAR]: 85,
  [OVERFLOW_IDS.SELECT_FILTER]: 90,
  [OVERFLOW_IDS.SEARCH_CATEGORY]: 100,
  [OVERFLOW_IDS.SEARCH]: 110
};

export const DASHBOARD_GEO_SELECT_MIN_WIDTH = 250;

function appendDateFilterCandidates(ids, context) {
  if (context.showMonthYearFilters) {
    ids.push(OVERFLOW_IDS.MONTH_YEAR);
    return;
  }

  if (!context.showDateFilters) {
    return;
  }

  ids.push(OVERFLOW_IDS.APPLY);
  if (context.showClearButton) {
    ids.push(OVERFLOW_IDS.CLEAR);
  }
  if (!context.singleDateFilter) {
    ids.push(OVERFLOW_IDS.END_DATE);
  }
  ids.push(OVERFLOW_IDS.START_DATE);
}

function appendDashboardGeoCandidates(ids, context) {
  if (!context.showDashboardGeoFilters) {
    return;
  }
  ids.push(OVERFLOW_IDS.DASHBOARD_PRIMARY, OVERFLOW_IDS.DASHBOARD_SECONDARY);
}

export function isFilterlessTopbarContext(context = {}) {
  return !(
    context.showDashboardGeoFilters ||
    context.showSearch ||
    context.showSearchCategory ||
    context.showSelectFilter ||
    context.showDateFilters ||
    context.showMonthYearFilters
  );
}

export function getActiveOverflowCandidates(context) {
  const ids = [];

  appendDashboardGeoCandidates(ids, context);
  if (context.showSearchCategory) {
    ids.push(OVERFLOW_IDS.SEARCH_CATEGORY);
  }
  if (context.showSelectFilter) {
    ids.push(OVERFLOW_IDS.SELECT_FILTER);
  }
  appendDateFilterCandidates(ids, context);
  if (!context.isQmsOtpGuestSession && !context.isQmsPayrollClosureRole) {
    ids.push(OVERFLOW_IDS.HELP);
  }
  ids.push(OVERFLOW_IDS.DARK_MODE, OVERFLOW_IDS.NOTIFICATIONS);

  return ids.filter((id, index, list) => list.indexOf(id) === index);
}

/** On filter-less forms, keep moon/help/bell inline — never move them into "...". */
export function getCollapsibleOverflowCandidates(context) {
  const ids = getActiveOverflowCandidates(context);
  if (!isFilterlessTopbarContext(context)) {
    return ids;
  }
  const utilityIds = new Set(UTILITY_OVERFLOW_IDS);
  return ids.filter(id => !utilityIds.has(id));
}

export function clearUtilityOverflowIds(overflowedIds = []) {
  const utilityIds = new Set(UTILITY_OVERFLOW_IDS);
  return overflowedIds.filter(id => !utilityIds.has(id));
}

export function overflowSetsEqual(a, b) {
  if (a.length !== b.length) {
    return false;
  }
  const left = [...a].sort();
  const right = [...b].sort();
  return left.every((value, index) => value === right[index]);
}

export function pickNextOverflowId(candidateIds, overflowedIds) {
  const inlineIds = candidateIds.filter(id => !overflowedIds.has(id));
  if (inlineIds.length === 0) {
    return null;
  }
  return inlineIds.sort(
    (a, b) => (OVERFLOW_PRIORITY[a] || 999) - (OVERFLOW_PRIORITY[b] || 999)
  )[0];
}

export function pickRestoreOverflowId(candidateIds, overflowedIds) {
  const collapsedIds = candidateIds.filter(id => overflowedIds.has(id));
  if (collapsedIds.length === 0) {
    return null;
  }
  return collapsedIds.sort(
    (a, b) => (OVERFLOW_PRIORITY[b] || 999) - (OVERFLOW_PRIORITY[a] || 999)
  )[0];
}

export function sortOverflowPanelIds(overflowedIds) {
  return [...overflowedIds].sort(
    (a, b) => (OVERFLOW_PRIORITY[b] || 999) - (OVERFLOW_PRIORITY[a] || 999)
  );
}

export function pruneOverflowedIds(overflowedIds, candidateIds) {
  const candidates = new Set(candidateIds);
  return overflowedIds.filter(id => candidates.has(id));
}

export function topbarContentFits(rootEl) {
  if (!rootEl) {
    return true;
  }
  return rootEl.scrollWidth <= rootEl.clientWidth + 1;
}
